export default {
      id: "contacts-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "sprite.svg#contacts",
      toString: function () {
        return this.url;
      }
    }